import React, { useEffect, useState, useCallback } from 'react';
import AdminLayout from './AdminLayout';
import { useAuth } from '../../context/AuthContext';
import ConfirmModal from '../../components/ConfirmModal';
import api from '../../api/axios';
import { Plus, Search, Filter, X, Edit2, Trash2, ChevronDown, ChevronUp, CheckSquare, Paperclip, MessageSquare } from 'lucide-react';

const PRIORITY_COLORS = { kritik: '#ef4444', yuksek: '#f97316', normal: '#007aff', dusuk: '#9ca3af' };
const PRIORITY_LABELS = { kritik: '🔴 Kritik', yuksek: '🟠 Yüksek', normal: '🔵 Normal', dusuk: '⚪ Düşük' };
const STATUS_OPTIONS = [
  { value: 'yapilacak', label: 'Yapılacak', color: '#6b7280' },
  { value: 'devam-ediyor', label: 'Devam Ediyor', color: '#007aff' },
  { value: 'incelemede', label: 'İncelemede', color: '#ff9500' },
  { value: 'tamamlandi', label: 'Tamamlandı', color: '#34c759' },
];

const TaskModal = ({ task, onClose, onSave, projects, users }) => {
  const [form, setForm] = useState(task ? {
    title: task.title, description: task.description || '', project_id: task.project_id || '',
    status: task.status, priority: task.priority, assigned_to: task.assigned_to || '',
    reporter_id: task.reporter_id || '', department: task.department || '',
    start_date: task.start_date ? task.start_date.substring(0,10) : '',
    due_date: task.due_date ? task.due_date.substring(0,10) : ''
  } : { title: '', description: '', project_id: '', status: 'yapilacak', priority: 'normal', assigned_to: '', reporter_id: '', department: '', start_date: '', due_date: '' });

  const [detail, setDetail] = useState(null);
  const [newSubtask, setNewSubtask] = useState('');
  const [newComment, setNewComment] = useState('');
  const [activeTab, setActiveTab] = useState('form');

  useEffect(() => {
    if (task?.id) api.get('/tasks/tasks/' + task.id).then(r => setDetail(r.data));
  }, [task]);

  const save = async () => {
    if (!form.title.trim()) return;
    if (task?.id) await api.put('/tasks/tasks/' + task.id, form);
    else await api.post('/tasks/tasks', form);
    onSave();
  };

  const addSubtask = async () => {
    if (!newSubtask.trim() || !task?.id) return;
    await api.post('/tasks/tasks/' + task.id + '/subtasks', { title: newSubtask });
    setNewSubtask('');
    const r = await api.get('/tasks/tasks/' + task.id); setDetail(r.data);
  };

  const toggleSubtask = async (sub) => {
    await api.patch('/tasks/subtasks/' + sub.id, { is_completed: !sub.is_completed });
    const r = await api.get('/tasks/tasks/' + task.id); setDetail(r.data);
  };

  const deleteSubtask = async (subId) => {
    await api.delete('/tasks/subtasks/' + subId);
    const r = await api.get('/tasks/tasks/' + task.id); setDetail(r.data);
  };

  const addComment = async () => {
    if (!newComment.trim() || !task?.id) return;
    await api.post('/tasks/tasks/' + task.id + '/comments', { content: newComment });
    setNewComment('');
    const r = await api.get('/tasks/tasks/' + task.id); setDetail(r.data);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
      <div style={{ background: 'white', borderRadius: 20, width: '100%', maxWidth: 640, maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 32px 80px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '18px 22px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <div style={{ fontWeight: 700, fontSize: 16, color: '#1a1a2e' }}>{task?.id ? 'Görevi Düzenle' : 'Yeni Görev'}</div>
          <button onClick={onClose} style={{ background: 'rgba(0,0,0,0.06)', border: 'none', borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><X size={14} /></button>
        </div>

        {task?.id && (
          <div style={{ display: 'flex', padding: '0 22px', borderBottom: '1px solid #f0f0f0', flexShrink: 0 }}>
            {[['form','Detaylar'],['subtasks','Alt Görevler'],['comments','Yorumlar'],['activity','Aktivite']].map(([key, label]) => (
              <button key={key} onClick={() => setActiveTab(key)}
                style={{ padding: '10px 14px', border: 'none', borderBottom: `2px solid ${activeTab === key ? '#007aff' : 'transparent'}`, background: 'transparent', cursor: 'pointer', fontWeight: activeTab === key ? 700 : 500, fontSize: 13, color: activeTab === key ? '#007aff' : '#6b7280' }}>
                {label}
              </button>
            ))}
          </div>
        )}

        <div style={{ flex: 1, overflowY: 'auto', padding: '18px 22px' }}>
          {activeTab === 'form' && (
            <>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 12, color: '#6b7280' }}>BAŞLIK *</label>
                <input value={form.title} onChange={e => setForm({...form, title: e.target.value})}
                  style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 12, color: '#6b7280' }}>AÇIKLAMA</label>
                <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})} rows={3}
                  style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 14, outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit' }} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                <div>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 12, color: '#6b7280' }}>PROJE</label>
                  <select value={form.project_id} onChange={e => setForm({...form, project_id: e.target.value})}
                    style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none' }}>
                    <option value="">Seçin...</option>
                    {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 12, color: '#6b7280' }}>DURUM</label>
                  <select value={form.status} onChange={e => setForm({...form, status: e.target.value})}
                    style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none' }}>
                    {STATUS_OPTIONS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 12, color: '#6b7280' }}>ÖNCELİK</label>
                  <select value={form.priority} onChange={e => setForm({...form, priority: e.target.value})}
                    style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none' }}>
                    {Object.entries(PRIORITY_LABELS).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 12, color: '#6b7280' }}>ATANAN KİŞİ</label>
                  <select value={form.assigned_to} onChange={e => setForm({...form, assigned_to: e.target.value})}
                    style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none' }}>
                    <option value="">Seçin...</option>
                    {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 12, color: '#6b7280' }}>BAŞLANGIÇ</label>
                  <input type="date" value={form.start_date} onChange={e => setForm({...form, start_date: e.target.value})}
                    style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 12, color: '#6b7280' }}>TESLİM TARİHİ</label>
                  <input type="date" value={form.due_date} onChange={e => setForm({...form, due_date: e.target.value})}
                    style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
                </div>
              </div>
            </>
          )}

          {activeTab === 'subtasks' && detail && (
            <div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                <input value={newSubtask} onChange={e => setNewSubtask(e.target.value)} placeholder="Yeni alt görev..."
                  onKeyDown={e => e.key === 'Enter' && addSubtask()}
                  style={{ flex: 1, padding: '9px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none' }} />
                <button onClick={addSubtask} style={{ background: '#007aff', color: 'white', border: 'none', borderRadius: 10, padding: '0 16px', cursor: 'pointer', fontWeight: 600 }}>Ekle</button>
              </div>
              <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 10 }}>
                {detail.subtasks?.filter(s => s.is_completed).length || 0} / {detail.subtasks?.length || 0} tamamlandı
              </div>
              {detail.subtasks?.map(sub => (
                <div key={sub.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid #f5f5f5' }}>
                  <input type="checkbox" checked={sub.is_completed} onChange={() => toggleSubtask(sub)} style={{ width: 16, height: 16, cursor: 'pointer' }} />
                  <span style={{ flex: 1, fontSize: 13, color: sub.is_completed ? '#9ca3af' : '#374151', textDecoration: sub.is_completed ? 'line-through' : 'none' }}>{sub.title}</span>
                  <button onClick={() => deleteSubtask(sub.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', padding: 4 }}><X size={13} /></button>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'comments' && detail && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Yorum yazın..." rows={3}
                  style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none', resize: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }} />
                <button onClick={addComment} style={{ background: '#007aff', color: 'white', border: 'none', borderRadius: 10, padding: '8px 20px', cursor: 'pointer', fontWeight: 600, marginTop: 8 }}>Yorum Ekle</button>
              </div>
              {detail.comments?.map(c => (
                <div key={c.id} style={{ background: '#f9fafb', borderRadius: 10, padding: '12px 14px', marginBottom: 10 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, color: '#374151' }}>{c.user_name}</div>
                    <div style={{ fontSize: 11, color: '#9ca3af' }}>{new Date(c.created_at).toLocaleDateString('tr-TR')}</div>
                  </div>
                  <div style={{ fontSize: 13, color: '#374151', lineHeight: 1.6 }}>{c.content}</div>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'activity' && detail && (
            <div>
              {detail.activities?.map((a, i) => (
                <div key={i} style={{ display: 'flex', gap: 10, padding: '10px 0', borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontSize: 18 }}>📌</span>
                  <div>
                    <div style={{ fontSize: 12, color: '#374151' }}><strong>{a.user_name}</strong> — {a.description}</div>
                    <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>{new Date(a.created_at).toLocaleString('tr-TR')}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {(activeTab === 'form') && (
          <div style={{ padding: '14px 22px', borderTop: '1px solid #f0f0f0', display: 'flex', gap: 10, justifyContent: 'flex-end', flexShrink: 0 }}>
            <button onClick={onClose} style={{ padding: '9px 18px', border: '1.5px solid #e5e7eb', borderRadius: 10, background: 'white', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
            <button onClick={save} style={{ padding: '9px 24px', background: 'linear-gradient(135deg, #007aff, #5856d6)', color: 'white', border: 'none', borderRadius: 10, cursor: 'pointer', fontWeight: 600 }}>
              {task?.id ? 'Güncelle' : 'Oluştur'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default function AdminTaskList() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const [confirmModal, setConfirmModal] = React.useState({ open: false, action: null, title: '', message: '' });
  const showConfirm = (title, message, action) => setConfirmModal({ open: true, title, message, action });
  const closeConfirm = () => setConfirmModal({ open: false, action: null, title: '', message: '' });
  const [tasks, setTasks] = useState([]);
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [filters, setFilters] = useState({ search: '', project_id: '', status: '', priority: '', overdue: '' });
  const [showModal, setShowModal] = useState(false);
  const [editingTask, setEditingTask] = useState(null);

  const loadTasks = useCallback(() => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => { if (v) params.append(k, v); });
    api.get('/tasks/tasks?' + params.toString()).then(r => setTasks(r.data));
  }, [filters]);

  useEffect(() => {
    loadTasks();
    api.get('/tasks/projects').then(r => setProjects(r.data));
    api.get('/users').then(r => setUsers(r.data.filter(u => u.role === 'admin')));
  }, [loadTasks]);

  const deleteTask = (id) => {
    showConfirm('Görevi Sil', 'Bu görevi silmek istediğinize emin misiniz?', async () => {
      await api.delete('/tasks/tasks/' + id);
      loadTasks();
      closeConfirm();
    });
  };

  return (
    <AdminLayout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ fontWeight: 700, fontSize: 22, color: '#1a1a2e', display: 'flex', alignItems: 'center', gap: 10 }}>
          <CheckSquare size={22} color="#007aff" /> Görev Listesi
        </h2>
        <button onClick={() => { setEditingTask(null); setShowModal(true); }}
          style={{ background: 'linear-gradient(135deg, #007aff, #5856d6)', color: 'white', border: 'none', borderRadius: 10, padding: '10px 18px', cursor: 'pointer', fontWeight: 600, fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
          <Plus size={14} /> Yeni Görev
        </button>
      </div>

      {/* Filtreler */}
      <div style={{ background: 'rgba(255,255,255,0.85)', borderRadius: 14, padding: '14px 16px', marginBottom: 16, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, border: '1.5px solid #e5e7eb', borderRadius: 10, padding: '7px 12px', flex: 1, minWidth: 180 }}>
          <Search size={14} color="#9ca3af" />
          <input placeholder="Görev ara..." value={filters.search} onChange={e => setFilters({...filters, search: e.target.value})}
            style={{ border: 'none', outline: 'none', fontSize: 13, flex: 1, background: 'transparent' }} />
        </div>
        <select value={filters.project_id} onChange={e => setFilters({...filters, project_id: e.target.value})}
          style={{ padding: '8px 12px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none' }}>
          <option value="">Tüm Projeler</option>
          {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
        <select value={filters.status} onChange={e => setFilters({...filters, status: e.target.value})}
          style={{ padding: '8px 12px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none' }}>
          <option value="">Tüm Durumlar</option>
          {STATUS_OPTIONS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
        <select value={filters.priority} onChange={e => setFilters({...filters, priority: e.target.value})}
          style={{ padding: '8px 12px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none' }}>
          <option value="">Tüm Öncelikler</option>
          {Object.entries(PRIORITY_LABELS).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#374151', cursor: 'pointer' }}>
          <input type="checkbox" checked={filters.overdue === 'true'} onChange={e => setFilters({...filters, overdue: e.target.checked ? 'true' : ''})} />
          Sadece Gecikenler
        </label>
        {Object.values(filters).some(v => v) && (
          <button onClick={() => setFilters({ search: '', project_id: '', status: '', priority: '', overdue: '' })}
            style={{ padding: '7px 12px', border: '1.5px solid #e5e7eb', borderRadius: 10, background: 'white', cursor: 'pointer', fontSize: 12, color: '#6b7280', display: 'flex', alignItems: 'center', gap: 4 }}>
            <X size={12} /> Temizle
          </button>
        )}
      </div>

      {/* Görev tablosu */}
      <div style={{ background: 'rgba(255,255,255,0.85)', borderRadius: 14, overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 700 }}>
            <thead>
              <tr style={{ background: 'rgba(0,0,0,0.02)' }}>
                {['GÖREV', 'PROJE', 'DURUM', 'ÖNCELİK', 'ATANAN', 'TESLİM', 'İLERLEME', 'İŞLEM'].map(h => (
                  <th key={h} style={{ padding: '11px 14px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tasks.map(t => {
                const status = STATUS_OPTIONS.find(s => s.value === t.status);
                const isOverdue = t.is_overdue;
                return (
                  <tr key={t.id} style={{ borderTop: '1px solid rgba(0,0,0,0.04)' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,122,255,0.02)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '11px 14px', maxWidth: 200 }}>
                      <div style={{ fontWeight: 600, fontSize: 13, color: '#1a1a2e', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.title}</div>
                      {(parseInt(t.total_subtasks) > 0) && (
                        <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 2 }}>
                          ✓ {t.completed_subtasks}/{t.total_subtasks}
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '11px 14px' }}>
                      {t.project_name && <span style={{ background: (t.project_color || '#007aff') + '20', color: t.project_color || '#007aff', borderRadius: 20, padding: '2px 8px', fontSize: 11, fontWeight: 600 }}>{t.project_name}</span>}
                    </td>
                    <td style={{ padding: '11px 14px' }}>
                      <span style={{ background: (status?.color || '#6b7280') + '15', color: status?.color || '#6b7280', borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 700 }}>{status?.label}</span>
                    </td>
                    <td style={{ padding: '11px 14px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <div style={{ width: 8, height: 8, borderRadius: '50%', background: PRIORITY_COLORS[t.priority] }} />
                        <span style={{ fontSize: 12, color: PRIORITY_COLORS[t.priority], fontWeight: 600 }}>{PRIORITY_LABELS[t.priority]?.split(' ')[1]}</span>
                      </div>
                    </td>
                    <td style={{ padding: '11px 14px', fontSize: 12, color: '#374151' }}>{t.assigned_name || '—'}</td>
                    <td style={{ padding: '11px 14px' }}>
                      {t.due_date && <span style={{ fontSize: 11, color: isOverdue ? '#ef4444' : '#9ca3af', fontWeight: isOverdue ? 700 : 400 }}>
                        {isOverdue && '⚠️ '}{new Date(t.due_date).toLocaleDateString('tr-TR')}
                      </span>}
                    </td>
                    <td style={{ padding: '11px 14px', minWidth: 80 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <div style={{ flex: 1, height: 5, background: '#f0f0f0', borderRadius: 3 }}>
                          <div style={{ height: '100%', width: (t.progress || 0) + '%', background: '#007aff', borderRadius: 3 }} />
                        </div>
                        <span style={{ fontSize: 10, color: '#9ca3af', fontWeight: 600 }}>{t.progress || 0}%</span>
                      </div>
                    </td>
                    <td style={{ padding: '11px 14px' }}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => { setEditingTask(t); setShowModal(true); }}
                          style={{ background: 'rgba(0,122,255,0.08)', color: '#007aff', border: 'none', borderRadius: 7, padding: '5px 9px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                          <Edit2 size={12} />
                        </button>
                        {isAdmin && <button onClick={() => deleteTask(t.id)}
                          style={{ background: 'rgba(239,68,68,0.08)', color: '#ef4444', border: 'none', borderRadius: 7, padding: '5px 9px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                          <Trash2 size={12} />
                        </button>}
                      </div>
                    </td>
                  </tr>
                );
              })}
              {tasks.length === 0 && (
                <tr><td colSpan={8} style={{ padding: 40, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Görev bulunamadı</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <div style={{ padding: '10px 16px', borderTop: '1px solid rgba(0,0,0,0.04)', fontSize: 12, color: '#9ca3af' }}>
          Toplam {tasks.length} görev
        </div>
      </div>

      {showModal && (
        <TaskModal
          task={editingTask}
          onClose={() => { setShowModal(false); setEditingTask(null); }}
          onSave={() => { setShowModal(false); setEditingTask(null); loadTasks(); }}
          projects={projects}
          users={users}
        />
      )}
      <ConfirmModal
        isOpen={confirmModal.open}
        title={confirmModal.title}
        message={confirmModal.message}
        onConfirm={() => { confirmModal.action && confirmModal.action(); }}
        onCancel={closeConfirm}
        confirmText="Evet, Sil"
      />
    </AdminLayout>
  );
}
